import React, { useEffect } from "react";
import FormInput from "../../components/common/FormInput";
import { Form, Formik, FormikHelpers, FormikProps } from "formik";
import { LoaderButton } from "../../components/common/LoadingButton";
import {
  InvitedSignupFormValidationSchema,
  SignupFormInitialValues,
} from "../../utils/validation";
import { InvitedSignupFormValues, InvitedSignupPayload } from "types/signup";
import { useAuth } from "hooks/useAuth";
import { showToast } from "utils/toast";
import { motion } from 'framer-motion';

export default function Signup() {
  const { joinInvitedUser } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inviteToken = params.get("user-key");

    if (inviteToken) {
      sessionStorage.setItem("invite_token", inviteToken);
    }
  }, []);

  const handelSubmit = async (
    values: InvitedSignupFormValues,
    actions: FormikHelpers<InvitedSignupFormValues>,
  ) => {
    const inviteKeyFromUrl = sessionStorage.getItem("invite_token") ?? "";
    if (!inviteKeyFromUrl) {
      showToast.error(
        "Invitation token is missing. Please use the invite link sent to your email.",
      );
      return;
    }
    const payload: InvitedSignupPayload = {
      firstName: values.firstName,
      lastName: values.lastName,
      password: values.password,
      confirmPassword: values.confirmPassword,
    };
    await joinInvitedUser(inviteKeyFromUrl, payload);

    actions.resetForm();
    sessionStorage.removeItem("invite_token");
  };

  return (
  <div className="bg-primary rounded-2xl border shadow-lg border-[#222735] w-full py-8 px-4 overflow-y-auto">

    <div className="text-center">
      <motion.img
        src="/assets/worklap-white-logo.svg"
        className="mx-auto w-10"
        alt="Worklap Logo"
        animate={{ rotate: 360 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      />
      <h1 className="font-semibold text-xl md:text-2xl w-full mt-[18px]">
        Get Started
      </h1>
      <p className="text-sm text-neutral-medium pt-[7px]">
        Create a password for your workspace
      </p>
    </div>

    <Formik<InvitedSignupFormValues>
      initialValues={SignupFormInitialValues}
      validationSchema={InvitedSignupFormValidationSchema}
      onSubmit={handelSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isValid, dirty, isSubmitting }: FormikProps<InvitedSignupFormValues>) => (
        <Form onSubmit={handleSubmit}>
          <div className="w-full max-w-[400px] mx-auto pt-6 space-y-5">
            <div className="flex flex-col sm:flex-row gap-5">
              <FormInput name="firstName" type="text" value={values.firstName} onChange={handleChange} onBlur={handleBlur} error={touched.firstName && errors.firstName} placeholder="First Name" darkBg whiteLabel />
              <FormInput name="lastName" type="text" value={values.lastName} onChange={handleChange} onBlur={handleBlur} error={touched.lastName && errors.lastName} placeholder="Last Name" darkBg whiteLabel />
            </div>
            <FormInput name="password" type="password" value={values.password} onChange={handleChange} onBlur={handleBlur} error={touched.password && errors.password} placeholder="Create Password" darkBg whiteLabel />
            <FormInput name="confirmPassword" type="password" value={values.confirmPassword} onChange={handleChange} onBlur={handleBlur} error={touched.confirmPassword && errors.confirmPassword} placeholder="Confirm Password" darkBg whiteLabel />
            <div className="pt-2">
              <LoaderButton isLoading={isSubmitting} disabled={!isValid || !dirty || isSubmitting} className="!w-full" text="Confirm" />
            </div>
          </div>
        </Form>
      )}
    </Formik>

  </div>
);
}
